{
	"kind": {
		"PHOTO": "Accreditation photo",
		"TV_PHOTO": "TV photo",
		"ID_FRONT": "MyKad (front)",
		"ID_BACK": "MyKad (back)",
		"SUPPORTING_DOC": "Supporting document",
		"passport": "Passport photo page"
	},
	"docType": {
		"MEDICAL_CERTIFICATE": "Medical certificate",
		"TUE": "Anti-doping TUE",
		"PARENTAL_CONSENT": "Parental consent",
		"PROOF_OF_ELIGIBILITY": "Proof of eligibility",
		"WORK_PASS": "Work pass",
		"MEDIA_PASS": "Media pass",
		"OTHER": "Other document"
	},
	"problem": {
		"typeImage": "Use a JPG, PNG or WEBP image.",
		"typeAny": "Use a JPG, PNG or WEBP image, or a PDF.",
		"size": "The file is larger than {{mb}} MB.",
		"unreadable": "This image could not be opened. Try a JPG or PNG.",
		"tooSmall": "The photo is {{width}} × {{height}} px. It must be at least {{minWidth}} × {{minHeight}} px."
	},
	"progress": {
		"uploading": "Uploading… {{percent}}%",
		"processing": "Checking the file…",
		"cancel": "Cancel upload"
	},
	"photo": {
		"rule": "Portrait 4:5, at least {{width}} × {{height}} px",
		"size": "{{width}} × {{height}} px, 4:5",
		"upload": "Upload photo",
		"change": "Change photo",
		"remove": "Remove",
		"readOnly": "Not added yet.",
		"saved": "Photo saved",
		"removed": "Photo removed",
		"removeFailed": "Photo not removed",
		"removeTitle": "Remove the {{name}}?",
		"removeBody": "The photo is deleted from this card. The change is recorded in the card's activity.",
		"notWhite": "The background does not look white. Use a plain white background."
	},
	"rules": {
		"photoTitle": "Photo rules",
		"tvTitle": "TV photo rules",
		"face": "Facing the camera, no hat, taken in the last 6 months",
		"white": "Plain white background, clear contrast with clothes",
		"anyBackground": "Any plain background; formal clothes not needed",
		"head": "Head and shoulders fill most of the frame, centred",
		"portrait": "Portrait 4:5, at least {{width}} × {{height}} px"
	},
	"crop": {
		"titlePhoto": "Crop the accreditation photo",
		"titleTv": "Crop the TV photo",
		"description": "Drag to place the face in the frame. Zoom to fit the head and shoulders.",
		"area": "Crop area. Drag or use the arrow keys to move the photo.",
		"zoom": "Zoom",
		"output": "Saved at {{width}} × {{height}} px",
		"save": "Save photo",
		"cancel": "Cancel"
	},
	"docs": {
		"title": "Supporting documents",
		"empty": "No documents yet.",
		"add": "Add a document",
		"pickTitle": "Add a document",
		"pickHint": "Choose the type, then the file. JPG, PNG, WEBP or PDF, up to {{mb}} MB.",
		"limit_one": "This card has reached the limit of {{count}} document.",
		"limit_other": "This card has reached the limit of {{count}} documents.",
		"added": "Document added",
		"removed": "Document removed",
		"removeFailed": "Document not removed",
		"remove": "Remove {{name}}",
		"removeTitle": "Remove this document?",
		"removeBody": "{{type}} ({{name}}) is deleted from this card. The change is recorded in the card's activity.",
		"removeConfirm": "Remove document",
		"restricted": "Medical document: only a few people can open it",
		"restrictedHint": "Only the registering organisation, admins and the medical desk can open it."
	},
	"tile": {
		"missing": "Missing",
		"none": "None",
		"added": "Added",
		"pdf": "PDF",
		"image": "Image",
		"size": "{{width}} × {{height}} px",
		"open": "View {{name}}",
		"openPdf": "Open {{name}} in a new tab",
		"uploadedBy": "Uploaded by {{name}}, {{time}}",
		"uploadedAt": "Uploaded {{time}}"
	},
	"lightbox": {
		"counter": "{{n}} of {{total}}",
		"prev": "Previous",
		"next": "Next",
		"openTab": "Open in a new tab",
		"failed": "The file could not be opened."
	},
	"record": {
		"title": "Documents",
		"empty": "No documents on this card yet."
	},
	"chip": {
		"noPhotoCount_one": "No photo ({{n}})",
		"noPhotoCount_other": "No photo ({{n}})"
	}
}
